// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__28r1C","messages":"Chat_messages__3TvyJ","dateDivider":"Chat_dateDivider__qGN39"};